import type { RouteObject } from "react-router-dom";
import { MainTab, MarketingData } from "@admin/pages/analytics";

const routes = [{ index: true, element: <MainTab /> }] satisfies RouteObject[];

export const analyticsRoute = {
  path: "/analytics",
  children: routes,
} satisfies RouteObject;
